import React from "react";
import { connect } from "react-redux";
import { isEmpty } from "lodash";
import { Link } from "react-router-dom";
import EventList from "components/EventList";
import "./Dashboard.scss"
import RatingSection from "./components/RatingSection";
import HorizontalRule from "components/HorizontalRule";
import isEnabledFeature, { features } from "../../helpers/feature_flags";

const DashboardBody = ({ loaded, emptyEvents }) => {
  return (
    <>
      <h2>
        <img src={require("./bell-icon.svg")} /> Shift Alerts
      </h2>
      {
        loaded && emptyEvents ? (
          <div className="empty-events">
            <Link className="display-mobile btn btn-danger bold-button" to="create-event/1">
              Create New Event
            </Link>
            <h3>
              You currently have no events on the job board. Click the{" "}
              <i>Create New Event</i> button above to get started posting your
              events!
            </h3>
            <p>
              Once you create an event, you can manage your shift requests and
              alerts here.
            </p>
          </div>
        ) : (
          <div>
            <p>Manage your shift requests and event alerts here.</p>
            <EventList />
          </div>
        )
      }
    </>
  )
}

const UnderRatingFlagDashboard = ({ reviews }) => {
  return (
    <>
      <div className="header-rating-flag">
        <h1>dashboard</h1>
        <HorizontalRule hideResponsive />
        <Link className="btn btn-danger bold-button w-25" to="create-event/1">
          Create New Event
        </Link>
      </div>

      <RatingSection reviews={reviews} />
    </>
  )
}

const NormalDashboard = () => {
  return (
    <div className="header">
      <h1>dashboard</h1>
      <Link className="btn btn-danger bold-button" to="create-event/1">
        Create New Event
      </Link>
    </div>
  )
}

export const Dashboard = ({ emptyEvents, loaded, currentUser, reviews }) => (
  <div className="dashboard">
    {isEnabledFeature(features.RATING, currentUser) && reviews.length !== 0 ? <UnderRatingFlagDashboard reviews={reviews} /> : <NormalDashboard />}
    <DashboardBody
      emptyEvents={emptyEvents}
      loaded={loaded}
    />
  </div>
);

function mapStateToProps(state) {
  return {
    loaded: state.event.loaded.upcoming,
    emptyEvents: isEmpty(state.event.events.upcoming),
    currentUser: state.session.currentUser,
    reviews: state.review.pending,
  };
}

export default connect(mapStateToProps)(Dashboard);
